import { Stack } from "@mui/material";
import { useLayoutEffect } from "react";
import { ActivityListGroup } from "web_myplann/Activities/Components/ActivityListGroup";
import { DashboardSkeleton } from "web_myplann/Dashboard/Components/DashboardSkeleton";
import { useDashboardActivities } from "web_myplann/Dashboard/Hooks/useDashboardActivities";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type DashboardDataSectionProps = {
	onEmptyChange?: (isEmpty: boolean) => void;
};

export const DashboardDataSection = ({
	onEmptyChange,
}: DashboardDataSectionProps) => {
	const { t } = useResource();

	const {
		solvedEvents,
		upcomingEvents,
		overdueEvents,
		isLoading,
		allSectionsEmpty,
	} = useDashboardActivities();

	useLayoutEffect(() => {
		onEmptyChange?.(allSectionsEmpty);
	}, [onEmptyChange, allSectionsEmpty]);

	if (isLoading) {
		return (
			<Stack px={1.6} pt={2.4} gap={1}>
				<DashboardSkeleton height={150} />
			</Stack>
		);
	}

	if (allSectionsEmpty) {
		return null;
	}

	return (
		<Stack px={1.6} gap={1} pt={1.6}>
			<ActivityListGroup
				label={t(Resources.Common.solvedEvents)}
				{...solvedEvents}
				defaultNormalSize={1}
				noDivider={
					upcomingEvents.totalCount === 0 && overdueEvents.totalCount === 0
				}
			/>

			<ActivityListGroup
				label={t(Resources.Common.upcomingEvents)}
				{...upcomingEvents}
				defaultNormalSize={1}
				noDivider={overdueEvents.totalCount === 0}
			/>

			<ActivityListGroup
				label={t(Resources.Common.overdueEvents)}
				{...overdueEvents}
				defaultNormalSize={1}
				noDivider
			/>
		</Stack>
	);
};
